import React, { useState } from 'react';
import { Col, Form, Row, Typography } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { Button } from '../buttons/buttons';
import { FileUploadButton } from '../file-upload-button/file-upload-button';
import { useDictionaryTranslation } from '../../hooks/useDictionaryTranslation';

const FormImports = ({ downloadText, downloadRoute, uploadImportList }) => {
  const [fileList, setFileList] = useState([]);
  const { Link } = Typography;
  const { translate: t } = useDictionaryTranslation();

  return (
    <>
      <Form layout="vertical">
        <Row>
          <Col xs={24}>
            <Form.Item label={t(downloadText)}>
              <Link href={downloadRoute}>
                <Button type="secondary" icon={<DownloadOutlined />}>
                  {t('downloadTemplate')}
                </Button>
              </Link>
            </Form.Item>
          </Col>
          <Col xs={24}>
            <Form.Item label={t('uploadImportsTemplateMessage')}>
              <FileUploadButton
                buttonDirection="left"
                text={t('uploadTemplate')}
                color="secondary"
                maxCount={1}
                style={{ marginRight: '20px !important' }}
                fileList={fileList}
                setFileList={setFileList}
                onBeforeUpload={uploadImportList}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default FormImports;

FormImports.propTypes = {
  downloadText: PropTypes.string,
  downloadRoute: PropTypes.string,
  uploadImportList: PropTypes.func,
};
